module.exports = __webpack_public_path__ + "fonts/MavenPro-Black.aa0fa7c4.ttf";